// @flow

import { toastr } from "react-redux-toastr";
import { ticketDashboardTabs } from "../ticketDashboardHelper";
import { makeApiCall } from "../../../../../services/apiService/apiService";

export const ticketDashboardActions = {
  GET_ALL_TICKETS: "GET_ALL_TICKETS",
  GET_TICKETS_COUNT: "GET_TICKETS_COUNT",
  GET_DASHBOARD_TICKETS: "GET_DASHBOARD_TICKETS",
  GET_CLUSTER_LOCATION_MAPPING: "GET_CLUSTER_LOCATION_MAPPING",
  GET_TICKET_STATUS_OPTIONS: "GET_TICKET_STATUS_OPTIONS",
  BULK_CLOSE_TICKETS: "BULK_CLOSE_TICKETS",
  BULK_ASSIGN_TICKETS: "BULK_ASSIGN_TICKETS",
  GET_SEARCH_OPTIONS: "GET_SEARCH_OPTIONS"
};

export const getAllTicketsAction = (obj: Object) => ({
  type: ticketDashboardActions.GET_ALL_TICKETS,
  payload: obj
});

export const getSearchOptionsAction = (obj: Object) => ({
  type: ticketDashboardActions.GET_SEARCH_OPTIONS,
  payload: obj
});

export const getTicketsCountAction = (obj: Object) => ({
  type: ticketDashboardActions.GET_TICKETS_COUNT,
  payload: obj
});

export const getDashboardTicketsAction = (obj: Object) => ({
  type: ticketDashboardActions.GET_DASHBOARD_TICKETS,
  payload: obj
});

export const getClusterLocationMappingAction = (obj: Object) => ({
  type: ticketDashboardActions.GET_CLUSTER_LOCATION_MAPPING,
  payload: obj
});

export const getTicketStatusOptionsAction = (obj: Object) => ({
  type: ticketDashboardActions.GET_TICKET_STATUS_OPTIONS,
  payload: obj
});

export const bulkCloseTicketsAction = (obj: Object) => ({
  type: ticketDashboardActions.BULK_CLOSE_TICKETS,
  payload: obj
});

export const bulkAssignTicketsAction = (obj: Object) => ({
  type: ticketDashboardActions.BULK_ASSIGN_TICKETS,
  payload: obj
});

export const getAllTickets = () => (dispatch: Function) => {
  dispatch(
    getAllTicketsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getTicketsHistory",
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched all Tickets ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getAllTicketsAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getAllTicketsAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching tickets, res= ", res);
      dispatch(
        getAllTicketsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching tickets ", res);
      dispatch(
        getAllTicketsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

const getParamsFromSelectedData = data => {
  if (!data || !data.length) {
    return null;
  }
  return data.map(item => item.value);
};

const getQueryParams = (tab, locationCodeList, filters, isCountApi) => {
  const queryParams = [];
  if (filters) {
    if (filters.selectedCategories && filters.selectedCategories.length) {
      queryParams.push({
        key: "groupTypeIdList",
        val: getParamsFromSelectedData(filters.selectedCategories)
      });
    }
    if (filters.selectedTicketTypes && filters.selectedTicketTypes.length) {
      queryParams.push({
        key: "ticketTypeIdList",
        val: getParamsFromSelectedData(filters.selectedTicketTypes)
      });
    }
    if (filters.selectedStatus && filters.selectedStatus.length) {
      queryParams.push({
        key: "ticketStatusList",
        val: getParamsFromSelectedData(filters.selectedStatus)
      });
    }
    if (filters.pageNumber + 1) {
      queryParams.push({
        key: "pageNumber",
        val: filters && filters.pageNumber + 1
      });
    }
    if (filters.pageSize) {
      queryParams.push({ key: "pageSize", val: filters.pageSize });
    }
    if (filters.selectedSeverity) {
      queryParams.push({
        key: "severity",
        val: filters.selectedSeverity && filters.selectedSeverity.value
      });
    }
    if (filters.dateFilters) {
      if (filters.dateFilters.startDate && filters.dateFilters.endDate) {
        queryParams.push({
          key: "fromDate",
          val: filters.dateFilters.startDate
        });
        queryParams.push({
          key: "toDate",
          val: filters.dateFilters.endDate
        });
      }
    }
  }
  if (isCountApi || tab.label === ticketDashboardTabs.allMyBuTickets.label) {
    if (
      filters &&
      filters.selectedLocations &&
      filters.selectedLocations.length
    ) {
      queryParams.push({
        key: "locationCodeList",
        val: getParamsFromSelectedData(filters.selectedLocations)
      });
    } else if (filters && filters.selectedCluster) {
      queryParams.push({
        key: "locationCodeList",
        val: locationCodeList
      });
    }
  }
  return queryParams;
};

const getReplaceParamsForDashboardApi = (tab, locationCodeList, filters) => {
  if (tab.label === "Search") {
    return [
      { key: "searchTag", val: tab.key },
      { key: "searchId", val: tab.val }
    ];
  }
  return getQueryParams(tab, locationCodeList, filters, false);
};

export const getDashboardTickets = (tab, locationCodeList, filters) => (
  dispatch: Function
) => {
  dispatch(
    getDashboardTicketsAction({
      label: tab.label,
      searchText: tab.val,
      key: tab.key,
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: tab.apiEndPoint,
    replaceParamsArr: getReplaceParamsForDashboardApi(
      tab,
      locationCodeList,
      filters
    ),
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched dashboard Tickets ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getDashboardTicketsAction({
            label: tab.label,
            key: tab.key,
            searchText: tab.val,
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getDashboardTicketsAction({
            label: tab.label,
            key: tab.key,
            searchText: tab.val,
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching dashboard tickets, res= ", res);
      dispatch(
        getDashboardTicketsAction({
          label: tab.label,
          key: tab.key,
          searchText: tab.val,
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching dashboard tickets ", res);
      dispatch(
        getDashboardTicketsAction({
          label: tab.label,
          key: tab.key,
          searchText: tab.val,
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getTicketsCount = (tab, locationCodeList, filters) => (
  dispatch: Function
) => {
  dispatch(
    getTicketsCountAction({
      isLoading: true,
      isLoaded: false,
      data: {}
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getTicketsCount",
    replaceParamsArr: getQueryParams(tab, locationCodeList, filters, true),
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched Tickets count ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getTicketsCountAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
        dispatch(getDashboardTickets(tab, locationCodeList, filters));
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getTicketsCountAction({
            isLoading: false,
            isLoaded: true,
            data: {}
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching tickets count , res= ", res);
      dispatch(
        getTicketsCountAction({
          isLoading: false,
          isLoaded: true,
          data: {}
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching tickets count ", res);
      dispatch(
        getTicketsCountAction({
          isLoading: false,
          isLoaded: true,
          data: {}
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getClusterLocationMapping = (tab, filters) => (
  dispatch: Function
) => {
  dispatch(
    getClusterLocationMappingAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getClusterLocationMapping",
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched cluster location mapping ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getClusterLocationMappingAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
        dispatch(
          getTicketsCount(
            tab,
            res.response &&
              res.response[
                filters.selectedCluster && filters.selectedCluster.value
              ],
            filters
          )
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getClusterLocationMappingAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching cluster location mapping, res= ", res);
      dispatch(
        getClusterLocationMappingAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching cluster location mapping ", res);
      dispatch(
        getClusterLocationMappingAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getTicketStatusOptions = () => (dispatch: Function) => {
  dispatch(
    getTicketStatusOptionsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getTicketStatusOptions",
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched ticket status options ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getTicketStatusOptionsAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getTicketStatusOptionsAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching ticket status options , res= ", res);
      dispatch(
        getTicketStatusOptionsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching ticket status options ", res);
      dispatch(
        getTicketStatusOptionsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const bulkCloseTickets = (
  ticketIdList,
  reasonOfClosure,
  tab,
  locationCodeList,
  filters
) => (dispatch: Function) => {
  dispatch(
    bulkCloseTicketsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "bulkClose",
    method: "PUT",
    data: { ticketIdList, reasonOfClosure },
    successCb: res => {
      //  eslint-disable-next-line
      if (res.status === "SUCCESS") {
        dispatch(
          bulkCloseTicketsAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
        dispatch(getTicketsCount(tab, locationCodeList, filters));
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          bulkCloseTicketsAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in bulk closure of tickets, res= ", res);
      toastr.error("Error", res.errorMessage);
      dispatch(
        bulkCloseTicketsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in bulk closure of tickets, res= ", res);
      toastr.error("Error", res.errorMessage);
      dispatch(
        bulkCloseTicketsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const bulkAssignTickets = (
  ticketIdList,
  assigneeType,
  assigneeId,
  tab,
  locationCodeList,
  filters
) => (dispatch: Function) => {
  dispatch(
    bulkAssignTicketsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "bulkAssign",
    method: "PUT",
    data: { ticketIdList, assigneeType, assigneeId },
    successCb: res => {
      //  eslint-disable-next-line
      if (res.status === "SUCCESS") {
        dispatch(
          bulkAssignTicketsAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
        dispatch(getTicketsCount(tab, locationCodeList, filters));
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          bulkAssignTicketsAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in bulk assignment of tickets , res= ", res);
      toastr.error("Error", res.errorMessage);
      dispatch(
        bulkAssignTicketsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in bulk assignment of tickets, res= ", res);
      toastr.error("Error", res.errorMessage);
      dispatch(
        bulkAssignTicketsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getSearchOptions = () => (dispatch: Function) => {
  dispatch(
    getSearchOptionsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getTicketSearchOptions",
    successCb: res => {
      //	eslint-disable-next-line
      console.log("Fetched all search options, {} ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getSearchOptionsAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getSearchOptionsAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching search options, res= ", res);
      dispatch(
        getSearchOptionsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching search options ", res);
      dispatch(
        getSearchOptionsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/ticketDashboard/ticketDashboardRedux/ticketDashboardActionCreator.js